/* eslint-disable vue/return-in-computed-property */
<template>
<div>
    <md-card-actions md-alignment="space-between">
        <div class="">
            <p class="card-category">
                {{ total === 0 ? 0 : from + 1}} a {{ to }} de {{ total }} Registros.
            </p>
        </div>
        <slot />
        <!-- <pagination class="pagination-no-border pagination-site" v-model="currentPage" :per-page="perPage" :total="total">
        </pagination> -->
        <!-- <pagination class="pagination-no-border pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total">
        </pagination> -->
    </md-card-actions>
</div>
</template>

<script>

export default {
    name: 'FooterTable',

    props: ['from', 'to', 'total'],

    methods: {

    },
}
</script>

<style>
.btn-excel button {
    background-color: transparent !important;
    border: none !important;
    padding-left: 0 !important;
}

.btn-excel :hover {
    color: #fff !important;
}
</style>
